import axios from 'axios';
import { useState } from 'react';
import { Link } from 'react-router-dom'
import { CONSUMERS } from '../../../Utilities/APIs';
// import Logo from '../../Partials/Elements/Logo/Logo';

import './Auth.css';

function RecoverPassOne() {

    const [emailSent, setEmailSent] = useState(false)
    const [email, setEmail] = useState('')

    async function handleSubmit(e) {
        e.preventDefault()
        if (email.length > 0) {
            const forgotPass = await axios.post(CONSUMERS + 'forgotConsumerPassword', {email})
            if (forgotPass) {
                console.log(forgotPass)
                setEmailSent(true)
            }
        }
    }

    return (
        <section className="recover_pass page_padding">
            <div className="container">
                {/* <div className="page_logo">
                    <Logo />
                </div> */}
                {
                    emailSent
                    ?
                    <div className="centered_form_wrapper">
                        <div className="form_wrapper">
                            <h3>Recover Password</h3>
                            <div className="input_group" style={{marginBottom: '1rem'}}>
                                <p className="body_text">
                                    An email has been sent to {email}.
                                </p>
                            </div>
                            <div className="dha_box" style={{marginTop: '0'}}>
                                <p className="body_text">Didn’t receive any mail yet?</p>
                                <button type='submit' className='btn_text sign_up'>resend email</button>
                            </div>
                            <Link to='/login' className='btn_text forgot_pass'>Back to Login</Link>
                        </div>
                    </div>
                    :
                    <div className="centered_form_wrapper">
                        <div className="form_wrapper">
                            <h3>Recover Password</h3>
                            <form action="/">
                                <div className="input_group">
                                    <label className="input_field_label caption bold">Email</label>
                                    <input 
                                        type="email" 
                                        className="input_field body_text" 
                                        placeholder='Enter Email'
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                    />
                                    <p className="status" style={{marginTop: '.8rem'}}>We’ll email you a link that will let you change your password</p>
                                </div>
                                <button type='submit' className='btn_text btn_border' onClick={handleSubmit}>
                                    send recovery email
                                </button>
                            </form>
                            <Link to='/login' className='btn_text forgot_pass'>Back to Login</Link>

                            {/* <div className="dha_box">
                                <Link to='/login' className='btn_text sign_up'>Back to Login</Link>
                            </div> */}
                        </div>
                    </div>
                }
            </div>
        </section>
    )
}

export default RecoverPassOne